export const PURCHASE_STATISTICS_API = '/api/query-service/query/purchaseStatistics';
export const GOODS_RECEIPT_STATISTIC_API = '/api/query-service/query/goodsReceiptsStatistics';
